export default __webpack_public_path__ + "static/media/P800_CoC.e84d3a98.pdf";